import Sitemap, {
  getServerSideProps as hgetServerSideProps,
} from '@pages/myapp/sitemap';
import { GetServerSideProps } from 'next';

export const getServerSideProps: GetServerSideProps = hgetServerSideProps;

export default Sitemap;
